import axios from "axios";
import {apiUrl} from "../../App";

export async function getUserByUsernameUseCase(username: string) {
    return await axios.get(`${apiUrl}/admin/users/username/${username}`, {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
        },
    });
}